import React, { useEffect } from 'react';
import { RemoteMountedComponent } from '@classapp/sebastiao-orchestrator';
import Cookies from 'js-cookie';

import config from '../../../../../config/server.config';
import { createUrlWithHash } from '../../../utils';
import Loading from '../../../components/ui/Loading';
import {
  Container,
  Header,
  Title,
  Content
} from './ViewStyles';
import { __ } from '../../../i18n';

import { createStore } from '../../../store';

export default function ViewUI() {
  useEffect(() => {
    const store = createStore();
    const organization = store?.currentOrganization;
    const entity = store?.entity;
    const user = store?.currentUser;

    Cookies.set('organization', JSON.stringify({ fullname: organization?.fullname, id: organization?.id }));
    Cookies.set('entity', JSON.stringify({ fullname: entity?.fullname, id: entity?.id }));
    Cookies.set('user', JSON.stringify({ fullname: user?.fullname, id: user?.id }));
  });

  return (
    <Container>
      <Header>
        <Title>{__('Chats')}</Title>
      </Header>
      <Content>
        <RemoteMountedComponent
          url={createUrlWithHash(`${config.mcfPaths.chats}/remoteEntry.js`)}
          name="chatMcf"
          moduleName="./mountMethods"
          fallbackComponent={(
            <div style={{ display: 'flex' }}>
              <i className="icon warning red" style={{ fontWeight: 700 }} />
              <p>Erro ao carregar o componente</p>
            </div>
          )}
          loadingComponent={(
            <Loading width={30} height={30} />
          )}
        />
      </Content>
    </Container>
  );
}
